import axios from '../../api-client.ts';
import { useEffect, useState } from 'react';
import { useLoaderData, useParams } from 'react-router';
import LoadingSpinner from '../../../_mesomb/partials/components/LoadingSpinner.tsx';
import { AppConfig, PaymentLinkModel } from '../../../types';
import PayWithLink from './components/PayWithLink.tsx';

function PayWithLinkPage() {
  const { key } = useParams();
  const { configs, link: loadedLink } = useLoaderData<{ configs: AppConfig; link?: PaymentLinkModel }>();
  const [loading, setLoading] = useState<boolean>(true);
  const [link, setLink] = useState<PaymentLinkModel | undefined>(undefined);

  useEffect(() => {
    if (loadedLink) {setLink(loadedLink);setLoading(false);return;}
    setLoading(true);
    let stopped=false;
    axios
      .get<PaymentLinkModel>(`/payment/pay/${key}/`)
      .then((response) => {
        if(stopped)return;
        setLoading(false);
        setLink(response.data);
      })
      .catch(() => {
        if(stopped)return;
        setLoading(false);
        setLink(undefined);
      });
    return () => {stopped=true;};
  }, [key, loadedLink]);

  if (loading) {
    return <LoadingSpinner />;
  }

  return (
    <div className='d-flex flex-column flex-root'>
      <div className='d-flex flex-column flex-center flex-column-fluid'>
        <div className='d-flex flex-column p-10'>
          <PayWithLink link={link} configs={configs} />
        </div>
      </div>
    </div>
  );
}

export default PayWithLinkPage;
